/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react'
import Main from '../../../components/HOC/Main'
import SkillsForm from '../../../components/pages/SkillsForm'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/common/Button';
import { selectSelectedSkills, setSelectedSkills, toggleCommonDeleteModal, toggleSkillsSlide } from '../../../store/slices/common';
import CustomTable from '../../../components/common/CustomTable';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { clearSkillsData, deleteSkill, fetchSkills, selectSkillsData, setSkillsData } from '../../../store/slices/api/inner/skillsSlice';
import TableAction from '../../../components/TableAction';
import { FaPlus } from 'react-icons/fa';

export default function SkillsPage() {
  const dispatch = useDispatch();
  const skillsData = useSelector(selectSkillsData);
  const selectedSkills = useSelector(selectSelectedSkills);

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchSkills,
    setValueAction: setSkillsData,
    clearValueActionOnError: clearSkillsData,
    isForm: false,
    successMessage: false,
  });

  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedSkills(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedSkills(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(toggleCommonDeleteModal())
    dispatch(setSelectedSkills(null))
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deleteSkill,
    isForm: false,
    afterAPICall,
  });
  // delete end

  const handleEdit = (data) => {
    dispatch(setSelectedSkills(data));
    dispatch(toggleSkillsSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedSkills(null));
    dispatch(toggleSkillsSlide())
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
    },
    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Main crumbs={[{ title: "masters" }, { title: "skills" }]} handleDelete={() => {handleDelete({ skillId: selectedSkills.skill_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={skillsData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add Skill</Button>} />
      <SkillsForm defaultData={selectedSkills} fetchData={fetchData} />
    </Main>
  )
}
